<template>
  <div class="permisson-con">
    <div class="header">
      <div class="title">成员与权限</div>
    </div>
    <div class="search">
      <el-form inline class="inline-form" :model="searchForm" label-width="80px" label-position="left">
        <el-form-item label="手机号">
          <el-input v-model="searchForm.mobile" placeholder="请输入手机号" size="small"></el-input>
        </el-form-item>
        <el-form-item label="账号">
          <el-input v-model="searchForm.userName" placeholder="请输入账号" size="small"></el-input>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="searchForm.operateName" placeholder="请输入姓名" size="small"></el-input>
        </el-form-item>
        <el-button type="primary" @click="newMember" class="btnBase">创建成员</el-button>
        <el-button type="primary" @click="search" class="btnBase searchBtn">查询</el-button>
      </el-form>
    </div>
    <div class="table-list">
      <div class="tabledata-con">
        <el-table :data="tableData" style="width: 100%" border v-loading="loadingTable">
          <el-table-column prop="operatorName" label="姓名" align="center"></el-table-column>
          <el-table-column prop="userName" label="账号" align="center"> </el-table-column>
          <el-table-column prop="mobile" label="手机号" align="center"> </el-table-column>
          <el-table-column prop="merchantName" label="门店" align="center"> </el-table-column>
          <el-table-column prop="remark" label="备注" align="center"> </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button class="table-btn" type="primary" @click="deleteUser(scope.row)" v-show="scope.row.status == 0">注销</el-button>
              <el-button class="table-btn" type="primary" v-show="scope.row.status == 2" style="color:#ccc;">已注销</el-button>
              <el-button class="table-btn" type="primary" @click="modifyDetial(scope.row)" :disabled="scope.row.status == 2" :class="{'greeyBtn':scope.row.status==2}">修改</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-col :span="24" class="paginationBox">
          <el-pagination
            v-if="page.count > 0"
            class="pagination"
            prev-text="上一页"
            next-text="下一页"
            :page-size="page.pageSize"
            layout="prev, pager,total,next"
            :total="page.count"
            :current-page="page.pageNo"
            @current-change="onChangeCurrentPage"
          >
          </el-pagination>
        </el-col>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { listBackstageUserInfo, cancelBackstageUserInfo } from "@/api/member-permisson";

export default {
  name: "Mock",
  data() {
    return {
      searchForm: {
        mobile: "",
        userName: "",
        operateName: "",
      },
      page: {
        pageNo: 1,
        count: 0,
        pageSize: 10,
      },
      tableData: [],
      loadingTable: false,
    };
  },
  methods: {
    modifyDetial(row) {
      localStorage.setItem("memeberInfo", JSON.stringify(row));
      this.$router.push("/member-permisson/modifyInfo");
    },
    newMember() {
      localStorage.setItem("memeberInfo", JSON.stringify({}));
      this.$router.push("/member-permisson/modifyInfo");
    },
    deleteUser(row) {
      this.$confirm("删除账号后，此成员将不能使用此账号登录后台，并不可进行信息修改，确定要注销账号吗？", "注销账号", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const params = { userName: row.userName };
          cancelBackstageUserInfo(params).then((res) => {
            if (res.data.error_code === 0) {
              this.$message({
                showClose: true,
                message: "操作成功",
                type: "success",
              });
              this.queryData();
            }
          });
        })
        .catch(() => {});
    },
    /**
     * 改变当前页事件
     * @param  {number} page 当前页码
     */
    onChangeCurrentPage(page) {
      this.page.pageNo = page;
      this.queryData();
    },
    search() {
      this.page.pageNo = 1;
      this.queryData();
    },
    queryData() {
      const params = Object.assign(this.searchForm, this.page);
      this.loadingTable = true;
      listBackstageUserInfo(params).then((res) => {
        this.loadingTable = false;
        if (res.data.error_code === 0) {
          this.tableData = res.data.data.list;
          if (this.tableData.length > 0) {
            this.tableData.forEach((e1) => {
              e1.merchantName = e1.merchantList.map(e2 => e2.merchantName);
              e1.merchantName = e1.merchantName.join('，');
            });
          }
          this.page.count = res.data.data.totalCount;
        }
      });
    },
  },
  created() {
    this.queryData();
  },
};
</script>
<style lang="scss">
.permisson-con {
  > .header {
    padding-left: 50px;
    background-color: #fff;
    .title {
      height: 80px;
      line-height: 80px;
      color: #333333;
      font-size: 18px;
      position: relative;
      &:after {
        content: "";
        display: block;
        height: 0px;
        border-bottom: 1px solid #f2f3f3;
        right: 0;
        bottom: 0;
        left: -50px;
        position: absolute;
      }
    }
  }
  .search {
    padding: 40px 50px 20px;
    .btnBase {
      float: right;
      width: 90px;
      height: 32px;
      line-height: 0px;
      padding: 0;
    }
    .searchBtn {
      margin-right: 10px;
    }
    .el-form-item {
      margin-right: 40px;
    }
    .el-form--inline .el-form-item__label {
      color: #333333;
      font-size: 14px;
      font-weight: 400;
      min-width: 80px;
      .el-form-item__content {
        overflow: hidden;
      }
    }
  }
  .table-list {
    background: #f7f7f7;
    overflow: hidden;
    .tabledata-con {
      border-top: 20px solid #eee;
      padding: 40px 50px;
      background: #fff;
      overflow: hidden;
      .table-btn {
        margin-right: 10px;
        cursor: pointer;
        color: #ff9c00;
        background: transparent;
        border: none;
        padding: 0;
        margin: 0;
        width: 60px;
        height: 25px;
      }
      .greeyBtn{
        color: #ccc;
      }
    }
  }
}
</style>
